import { FC } from 'react';
import { Typography } from '@mui/material';

export const Label: FC = ({ children }) => (
  <Typography
    variant="caption"
    marginBottom={'3px'}
    className="demo-simple-select-label"
  >
    {children}
  </Typography>
);
